module.exports = __webpack_public_path__ + "img/shangwu.8f90b0c5.png";